<template>
    <div id="fiche-bu">
        <as-container>
            <div class="col flex">
                <as-title :title="$t('ficheBu.detail.title') + ' - ' + (selectedEntreprise?.nom || '')" :size="1" />
                <template v-if="!editMode">
                    <div class="ml-auto">
                        <Dropdown v-model="selectedEntrepriseId" :disabled="isBusy" :options="entreprisesOptions"
                            optionLabel="label" optionValue="value" @change="onSelectCompany" class="p-d-print-none" />
                        <Calendar v-model="selectedMonth" :disabled="isBusy" class="ml-3" style="width: 200px;"
                            view="month" dateFormat="mm/yy" @update:modelValue="onSelectMonth" />
                        <as-title class="hidden p-d-print-block"
                            :title="selectedEntreprise ? selectedEntreprise.nom : ''" :size="1" />
                    </div>
                    <Button id="download-pdf" :icon="pdfBeingGenerated ? 'pi pi-spin pi-spinner' : 'pi pi-download'"
                        :disabled="pdfBeingGenerated" iconPos="right" :label="$t('statistics.download_button')"
                        class="button-default ml-3" @click="downloadWithCSS" />
                </template>
            </div>
            <div id="pdf-first-and-second-section">
                <as-block shadow class="mb-5 mt-3">
                    <div class="flex">
                        <div class="col-12" id="pdf-first-section">
                            <template v-if="pdfBeingGenerated">
                                <as-title class="hidden p-d-print-block"
                                    :title="selectedEntreprise ? selectedEntreprise.nom : ''" :size="1" />
                                <div class="flex">
                                    <div class="col-6">
                                        <fiche-bu-safety-leader-manager-block class="mb-3" :edit="editMode"
                                            :ficheBu="ficheBu" :managerImg="managerImg"
                                            :selectedEntrepriseSafetyLeader="selectedEntreprise?.safetyLeader" />
                                        <fiche-bu-audit-block :isBusy="isMonthlyDataBusy" class="mb-3"
                                            :auditData="auditData" :edit="editMode" />
                                        <fiche-bu-performances-block class="mb-3" :graphYearlyData="graphYearlyData"
                                            :isBusy="isBigQueryDataBusy" />
                                        <fiche-bu-top-and-flop-stores-block :isBusy="isBigQueryDataBusy"
                                            :ficheBu="ficheBu" :selectedEntreprise="selectedEntreprise"
                                            :storesWithoutAccidentLast12Months="storesWithoutAccidentLast12Months"
                                            :edit="editMode" />
                                    </div>
                                    <div class="col-6">
                                        <fiche-bu-monthly-frequency-rate-graph class="mb-3"
                                            :graphMonthlyData="graphMonthlyData" :isBusy="isBigQueryDataBusy" />
                                        <fiche-bu-monthly-frequency-rate-progression-graph class="mb-3"
                                            :graphTtf1ProgressionData="graphTtf1ProgressionData"
                                            :selectedEntrepriseId="selectedEntrepriseId" :isBusy="isBigQueryDataBusy" />
                                    </div>
                                </div>
                                <div class="flex">
                                    <div class="col-12 p-3" id="pdf-second-section">
                                        <fiche-bu-monthly-news-block ref="ritualBlock"
                                            :pdfBeingGenerated="pdfBeingGenerated" :isBusy="isMonthlyDataBusy"
                                            :ritualSubjects="ritualSubjects" :lastRitualDates="lastRitualDates"
                                            class="mb-3" />
                                    </div>
                                </div>
                            </template>
                            <div class="flex" v-else>
                                <div class="col-12 lg:col-6 xl:col-5">
                                    <fiche-bu-safety-leader-manager-block class="mb-3" :edit="editMode"
                                        :ficheBu="ficheBu" :managerImg="managerImg"
                                        :selectedEntrepriseSafetyLeader="selectedEntreprise?.safetyLeader" />
                                    <fiche-bu-audit-block :isBusy="isMonthlyDataBusy" class="mb-3"
                                        :auditData="auditData" :edit="editMode" />
                                    <fiche-bu-performances-block class="mb-3" :graphYearlyData="graphYearlyData"
                                        :isBusy="isBigQueryDataBusy" />
                                    <fiche-bu-monthly-frequency-rate-graph class="mb-3"
                                        :graphMonthlyData="graphMonthlyData" :isBusy="isBigQueryDataBusy" />
                                    <fiche-bu-monthly-frequency-rate-progression-graph class="mb-3"
                                        :graphTtf1ProgressionData="graphTtf1ProgressionData"
                                        :selectedEntrepriseId="selectedEntrepriseId" :isBusy="isBigQueryDataBusy" />
                                    <fiche-bu-top-and-flop-stores-block :isBusy="isBigQueryDataBusy" :ficheBu="ficheBu"
                                        :selectedEntreprise="selectedEntreprise"
                                        :storesWithoutAccidentLast12Months="storesWithoutAccidentLast12Months"
                                        :edit="editMode" />
                                </div>
                                <div class="col-12 lg:col-6 xl:col-7" v-if="!pdfBeingGenerated">
                                    <fiche-bu-monthly-news-block ref="ritualBlock" :isBusy="isMonthlyDataBusy"
                                        :ritualSubjects="ritualSubjects" :lastRitualDates="lastRitualDates"
                                        class="mb-3" />
                                </div>
                            </div>
                        </div>
                    </div>
                </as-block>
            </div>
            <as-block shadow>
                <div class="flex">
                    <div class="col-12" id="pdf-third-section">
                        <div class="flex">
                            <div class="col-12 relative pl-4">
                                <img :src="safetyImage" class="accident-img m-0 background-default-lighter absolute" />
                                <div class="background-default pr-4">
                                    <as-title class="text-center color-white w-100"
                                        :title="$t('ficheBu.detail.evaluation_title')" :size="3"></as-title>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="background-default">
                                    <as-title class="text-center color-white w-100"
                                        :title="$t('ficheBu.detail.priority_title')" :size="3"></as-title>
                                </div>
                                <fiche-bu-priority-form-block :priorities="priorities" :edit="editMode"
                                    :pdfBeingGenerated="pdfBeingGenerated" />
                            </div>
                            <div class="col-12">
                                <div class="background-default">
                                    <as-title class="text-center color-white w-100"
                                        :title="$t('ficheBu.detail.battle_title')" :size="3"></as-title>
                                </div>
                                <fiche-bu-battle-form-block :battles="battles" :edit="editMode"
                                    :pdfBeingGenerated="pdfBeingGenerated" />
                            </div>
                        </div>
                    </div>
                </div>
            </as-block>
        </as-container>
        <div v-if="(isAdmin || (isSafetyLeader && isSameEntreprise)) && !editMode"
            class="grid actions-tab align-items w-100 justify-content-center">
            <Button :icon="'pi pi-pencil'" class="p-button-sm button-default mr-2" iconPos="right"
                :label="$t('cms_page.edit_category_label')" @click="enterEditMode">
            </Button>
        </div>
        <div v-show="editMode" class="grid actions-tab align-items w-100 justify-content-center">
            <Button v-if="editMode && (isAdmin || isSafetyLeader)"
                :icon="isBusy ? 'pi pi-spin pi-spinner' : 'pi pi-times'" :disabled="isBusy"
                class="p-button-sm button-default mr-2" iconPos="right" :label="$t('cms_page.cancel')"
                @click="handleQuitEditMode">
            </Button>
            <Button v-if="editMode && (isAdmin || isSafetyLeader)"
                :icon="isBusy ? 'pi pi-spin pi-spinner' : 'pi pi-check'" :disabled="isBusy"
                class="p-button-sm button-default" iconPos="right" :label="$t('cms_page.save')" @click="handleSave">
            </Button>
        </div>
        <as-confirm-modal :isVisible="showConfirmModal" :modalMessage="modalMessage" @onConfirm="confirmModal"
            @onCancel="cancelModal" />
    </div>
</template>

<script>
// @ is an alias to /src
import AsContainer from "@/components/Containers/AsContainer.vue";
import AsBlock from "@/components/Containers/AsBlock.vue";
import AsTitle from "@/components/Elements/AsTitle.vue";
import AsConfirmModal from "@/components/Modals/AsConfirmModal.vue";

import entreprisesServiceApi from "../services/entreprisesServiceApi";

import { mapGetters } from "vuex";
import roleMixins from "../mixins/roleMixins";

import Button from "primevue/button";
import Calendar from "primevue/calendar";
import Dropdown from "primevue/dropdown";
import Skeleton from "primevue/skeleton";

import modalModes from "../constantes/modalModes";
import fichiersServiceApi from "../services/fichiersServiceApi";
import BestPracticeBlock from "@/components/BestPractices/BestPracticeBlock.vue";
import FicheBuAuditBlock from "../components/FicheBu/FicheBuAuditBlock.vue";
import FicheBuBattleFormBlock from "../components/FicheBu/FicheBuBattleFormBlock.vue";
import FicheBuMonthlyFrequencyRateGraph from "../components/FicheBu/FicheBuMonthlyFrequencyRateGraph.vue";
import FicheBuMonthlyFrequencyRateProgressionGraph from "../components/FicheBu/FicheBuMonthlyFrequencyRateProgressionGraph.vue";
import FicheBuMonthlyNewsBlock from "../components/FicheBu/FicheBuMonthlyNewsBlock.vue";
import FicheBuPerformancesBlock from "../components/FicheBu/FicheBuPerformancesBlock.vue";
import FicheBuPriorityFormBlock from "../components/FicheBu/FicheBuPriorityFormBlock.vue";
import FicheBuSafetyLeaderManagerBlock from "../components/FicheBu/FicheBuSafetyLeaderManagerBlock.vue";
import FicheBuTopAndFlopStoresBlock from "../components/FicheBu/FicheBuTopAndFlopStoresBlock.vue";

import { getMonthlyData, getRateMonthlyData, saveFicheBuData, savePrioritiesAndBattlesStatusesData } from "@/services/ficheBuServiceApi";
import { bufferToBlobUrl } from "../util";
import apiEventTypes from "../constantes/apiEventTypes";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import moment from "moment";

export default {
    name: "FicheBu",
    components: {
        AsContainer,
        AsConfirmModal,
        AsTitle,
        AsBlock,
        Button,
        Calendar,
        Dropdown,

        BestPracticeBlock,
        FicheBuAuditBlock,
        FicheBuBattleFormBlock,
        FicheBuMonthlyFrequencyRateGraph,
        FicheBuMonthlyFrequencyRateProgressionGraph,
        FicheBuMonthlyNewsBlock,
        FicheBuPerformancesBlock,
        FicheBuPriorityFormBlock,
        FicheBuSafetyLeaderManagerBlock,
        FicheBuTopAndFlopStoresBlock,

        Skeleton,
    },
    computed: {
        ...mapGetters({
            user: "getUser",
        }),
        isSameEntreprise() {
            return this.user && this.user.idEntreprise === this.selectedEntreprise?.id;
        },
        entreprisesOptions() {
            return this.entreprises.map((el) => {
                return {
                    label: `${el.nom}`,
                    value: el.id,
                };
            });
        },
        getFormattedSelectedMonth() {
            return moment(this.selectedMonth).format('MM/YYYY')
        },
    },
    data() {
        return {
            safetyImage: new URL("../assets/images/safety.png", import.meta.url).href,
            editMode: false,
            showConfirmModal: false,
            modalMessage: "",
            entreprises: [],
            selectedEntreprise: undefined,
            selectedEntrepriseId: undefined,
            selectedMonth: new Date(),
            isMonthlyDataBusy: true,
            isBigQueryDataBusy: true,
            ficheBu: null,
            storesWithoutAccidentLast12Months: 0,
            graphYearlyData: null,
            graphMonthlyData: null,
            graphTtf1ProgressionData: null,
            lastRitualDates: [],
            ritualSubjects: [],
            lastBestPractice: null,
            lastBestPracticeNotation: 0,
            battles: [],
            priorities: [],
            managerImg: undefined,
            pdfBeingGenerated: false,
        };
    },
    watch: {
        user() {
            this.setSelectedEnterpriseFromUser()
        },
    },
    mixins: [roleMixins, fichiersServiceApi],
    beforeMount() {
        if (!this.isSafetyLeader && !this.isAdmin) {
            this.$router.push("/");
            return;
        }
        if (this.user && this.user.idEntreprise) { this.setSelectedEnterpriseFromUser() }
        this.getEntreprises();
        this.getMonthlyData();
        this.getRateMonthlyData();
    },
    methods: {
        setSelectedEnterpriseFromUser() {
            if (this.user && this.user.idEntreprise) {
                this.selectedEntreprise = this.entreprises.find(e => e.id === this.user.idEntreprise);
                this.selectedEntrepriseId = this.user.idEntreprise
            }
        },
        getEntreprises() {
            return entreprisesServiceApi
                .getEntreprises(true)
                .then((result) => {
                    this.entreprises = result;
                    this.setSelectedEnterpriseFromUser();
                    return Promise.resolve(result);
                })
                .catch((err) => {
                    return Promise.reject(err);
                });
        },
        async getMonthlyData() {
            try {
                this.isMonthlyDataBusy = true
                const monthlyData = await getMonthlyData(this.selectedMonth.getFullYear(), this.selectedMonth.getMonth() + 1, this.selectedEntrepriseId)
                if (monthlyData) {
                    const { ficheBu, auditData, lastRitualDates, ritualSubjects, lastBestPractice, lastBestPracticeNotation, battles, priorities, } = monthlyData
                    this.ficheBu = ficheBu
                    this.auditData = auditData
                    this.lastRitualDates = lastRitualDates
                    this.ritualSubjects = ritualSubjects
                    this.lastBestPractice = lastBestPractice
                    this.lastBestPracticeNotation = lastBestPracticeNotation
                    this.battles = battles
                    this.priorities = priorities

                    this.loadManagerImg(ficheBu.managerPhoto)
                }
            } catch (error) {
                console.log('error getMonthlyData =>', error)
            } finally {
                this.isMonthlyDataBusy = false
            }
        },
        async getRateMonthlyData() {
            this.isBigQueryDataBusy = true
            try {
                const selectedMonth = this.selectedMonth
                const enterpriseId = this.selectedEntrepriseId
                const monthlyData = await getRateMonthlyData(selectedMonth.getFullYear(), selectedMonth.getMonth() + 1, enterpriseId)
                if (monthlyData) {
                    const { frequencyRateAndGravityRate, storesWithoutAccidentLast12Months } = monthlyData
                    const { yearly, monthly, tf1Progression } = frequencyRateAndGravityRate
                    this.storesWithoutAccidentLast12Months = storesWithoutAccidentLast12Months
                    this.graphYearlyData = yearly
                    this.graphMonthlyData = monthly
                    this.graphTtf1ProgressionData = tf1Progression
                    this.selectedMonth = selectedMonth
                    this.selectedEntrepriseId = enterpriseId
                }
            } catch (error) {
                console.log('error getRateMonthlyData =>', error)
            } finally {
                this.isBigQueryDataBusy = false
            }

        },
        enterEditMode() {
            this.editMode = true;
        },
        handleQuitEditMode() {
            this.confirmModalMode = modalModes.CONFIRM_QUIT;
            this.modalMessage = this.$t(
                "confirm_modal.confirm_discard_change_message"
            );
            this.showConfirmModal = true;
        },
        handleSave() {
            this.confirmModalMode = modalModes.CONFIRM_SAVE;
            this.modalMessage = this.$t("confirm_modal.confirm_save_change_message");
            this.showConfirmModal = true;
        },
        confirmModal() {
            switch (this.confirmModalMode) {
                case modalModes.CONFIRM_SAVE:
                    this.save();
                    break;
                case modalModes.CONFIRM_QUIT:
                    this.quitEditMode();
                    break;
            }
        },
        cancelModal() {
            this.showConfirmModal = false;
        },
        quitEditMode() {
            this.getMonthlyData()
            this.editMode = false;
            this.showConfirmModal = false;
        },
        async save() {
            this.showConfirmModal = false
            this.isBigQueryDataBusy = true

            const managerImgToUpload = this.ficheBu.managerImgToUpload
            delete this.ficheBu.managerImgToUpload

            try {
                const year = this.selectedMonth.getFullYear()
                const month = this.selectedMonth.getMonth() + 1
                const buId = this.selectedEntrepriseId
                if (year && month && buId) {
                    let ficheBuId;
                    if (this.isSafetyLeader) {
                        ficheBuId = await savePrioritiesAndBattlesStatusesData(
                            year, month, buId,
                            {
                                battles: this.battles,
                                priorities: this.priorities
                            }
                        )
                    } else {
                        ficheBuId = await saveFicheBuData(
                            year, month, buId,
                            {
                                ficheBu: this.ficheBu,
                                auditData: this.auditData,
                                battles: this.battles,
                                priorities: this.priorities
                            }
                        )
                    }
                    if (ficheBuId) {
                        document.dispatchEvent(
                            new CustomEvent(apiEventTypes.API_SUCCESS, {
                                detail: {
                                    title: this.$t("popup_messages.success_title"),
                                    message: this.$t("popup_messages.success_created_message"),
                                },
                            })
                        )

                        if (managerImgToUpload) {
                            this._uploadManagerImg(managerImgToUpload, ficheBuId)
                        }
                    } else {
                        document.dispatchEvent(
                            new CustomEvent(apiEventTypes.API_ERROR, {
                                detail: {
                                    title: this.$t("popup_messages.default_error_title"),
                                    message: this.$t("popup_messages.default_error_message"),
                                },
                            })
                        );
                    }
                }
            } catch (error) {
                console.log('save error :', error)
            } finally {
                this.editMode = false
                this.isBigQueryDataBusy = false
                this.showConfirmModal = false
            }

        },
        async downloadWithCSS() {
            const ritualBlock = this.$refs.ritualBlock;
            ritualBlock.openAllPanels();

            await new Promise(r => setTimeout(r, 500));

            this.pdfBeingGenerated = true;
            this.$nextTick(async () => {
                await new Promise(r => setTimeout(r, 500));

                const doc = new jsPDF({ unit: "px", format: "a4" });
                const mainSection = document.getElementById("pdf-first-and-second-section");
                const thirdDiv = document.getElementById("pdf-third-section");

                const pdfWidth = doc.internal.pageSize.getWidth();
                const pdfHeight = doc.internal.pageSize.getHeight();
                const marginPdfY = 5; // Marge en haut et en bas égale à la marge visuelle gauche/droite
                const maxPdfHeight = pdfHeight - (marginPdfY * 2);

                const addDivToPDF = async (element, addPage = false) => {
                    const canvas = await html2canvas(element, { scale: 2 });
                    const imgWidth = pdfWidth;
                    const pageHeightInCanvas = (canvas.width * maxPdfHeight) / imgWidth;

                    // Fonction auxiliaire pour trouver une coupe "propre" (ligne de pixels blancs)
                    const findCleanSplitPoint = (ctx, startY, endY, width) => {
                        const imgData = ctx.getImageData(0, startY, width, endY - startY);
                        const data = imgData.data;

                        const isBg = (r, g, b) => {
                            // Blanc pur ou gris très clair des marges
                            if (r > 240 && g > 240 && b > 240) return true;
                            // #cfebee (background-primary-lighter)
                            if (Math.abs(r - 207) < 15 && Math.abs(g - 235) < 15 && Math.abs(b - 238) < 15) return true;
                            // #8bced6 (header sujet)
                            if (Math.abs(r - 139) < 15 && Math.abs(g - 206) < 15 && Math.abs(b - 214) < 15) return true;
                            // #189eab (titre mois)
                            if (Math.abs(r - 24) < 15 && Math.abs(g - 158) < 15 && Math.abs(b - 171) < 15) return true;
                            // Couleur probable de bordure grise panel (#dee2e6 / #e2e8f0)
                            if (Math.abs(r - 226) < 15 && Math.abs(g - 230) < 15 && Math.abs(b - 234) < 15) return true;
                            return false;
                        };

                        // On parcourt de bas en haut pour trouver la première ligne horizontale
                        // composée uniquement de pixels de fond clair
                        for (let y = endY - startY - 1; y >= 0; y--) {
                            let badPixelsCount = 0;
                            for (let x = 0; x < width; x++) {
                                const i = (y * width + x) * 4;
                                if (!isBg(data[i], data[i + 1], data[i + 2])) {
                                    badPixelsCount++;
                                }
                                // Tolérance de 25 pixels pour tolérer les éventuelles bordures verticales (gauche/droite)
                                if (badPixelsCount > 25) {
                                    break;
                                }
                            }
                            if (badPixelsCount <= 25) {
                                // On a trouvé une ligne horizontale propre de pixels de fond commun
                                return startY + y;
                            }
                        }

                        // Si aucune ligne complètement propre n'est trouvée (très rare ou image complexe)
                        // on retourne la hauteur max prévue par défaut
                        return endY;
                    };

                    const originalCtx = canvas.getContext("2d", { willReadFrequently: true });

                    let yPosCanvas = 0;
                    let isFirstPage = true;

                    while (yPosCanvas < canvas.height) {
                        const remainingHeight = canvas.height - yPosCanvas;
                        let srcHeight = Math.min(pageHeightInCanvas, remainingHeight);

                        // Si ce n'est pas la dernière page pour cet élément, on cherche un bon point de coupe
                        if (remainingHeight > pageHeightInCanvas) {
                            // On cherche une ligne "propre" sur les 150 derniers pixels de la zone prévue (scale 2 équivaut à 75px d'écran)
                            const searchStartY = Math.max(yPosCanvas, yPosCanvas + srcHeight - 150);
                            const searchEndY = yPosCanvas + srcHeight;

                            const cleanY = findCleanSplitPoint(originalCtx, searchStartY, searchEndY, canvas.width);
                            srcHeight = cleanY - yPosCanvas;

                            // Par sécurité, si on n'a vraiment pas trouvé de "zone" propre et qu'on a coupé tout en haut, on force la taille max
                            if (srcHeight <= 0) srcHeight = pageHeightInCanvas;
                        }

                        // Créer un canvas temporaire pour découper la portion de l'image
                        const tempCanvas = document.createElement("canvas");
                        tempCanvas.width = canvas.width;
                        tempCanvas.height = srcHeight;
                        const ctx = tempCanvas.getContext("2d");

                        // Dessiner la portion voulue
                        ctx.drawImage(
                            canvas,
                            0, yPosCanvas, canvas.width, srcHeight,
                            0, 0, tempCanvas.width, tempCanvas.height
                        );

                        const imgData = tempCanvas.toDataURL("image/jpeg", 0.7);
                        const imgHeightOnPdf = (srcHeight * imgWidth) / canvas.width;

                        if (addPage || !isFirstPage) {
                            doc.addPage();
                        }

                        doc.setFillColor('#fff');
                        doc.rect(0, 0, pdfWidth, pdfHeight, "F");
                        doc.addImage(imgData, "PNG", 0, marginPdfY, imgWidth, imgHeightOnPdf);

                        yPosCanvas += srcHeight;
                        isFirstPage = false;
                    }
                };

                await addDivToPDF(mainSection);
                await addDivToPDF(thirdDiv, true);

                doc.save(
                    `${this.selectedEntreprise?.nom ?? ""} - ${moment(this.selectedMonth).format("MM/YYYY")}`
                );
                this.pdfBeingGenerated = false;
                ritualBlock.restorePreviousState();
            });
        },

        onSelectCompany({ value }) {
            if (!this.isBigQueryDataBusy) {
                this.selectedEntreprise = this.entreprises.find(e => e.id === value);
                this.selectedEntrepriseId = value
                this._resetData()
                this.getMonthlyData()
                this.getRateMonthlyData()
            }
        },
        onSelectMonth() {
            if (!this.isBigQueryDataBusy) {
                this._resetData()
                this.getMonthlyData()
                this.getRateMonthlyData()
            }
        },
        async loadManagerImg(managerPhoto) {
            this.managerImg = undefined;
            if (managerPhoto && managerPhoto.externalId != null) {
                try {
                    const fichier = await this.downloadFile(managerPhoto.externalId);
                    this.managerImg = bufferToBlobUrl(fichier);
                } catch (error) {
                    console.log(error)
                }
            }
        },
        _resetData() {
            this.storesWithoutAccidentLast12Months = 0
            this.graphYearlyData = null
            this.graphMonthlyData = null
            this.lastRitualDates = []
            this.ritualSubjects = []
            this.lastBestPractice = null
        },
        async _uploadManagerImg(file, ficheBuId) {
            this.uploadFiles([{ file }], "fiche-bu-manager-img", ficheBuId, +this.user.idLdap, () => {
                this.getMonthlyData()
            })
        },
    },
};
</script>

<style lang="scss">
@import "../assets/styles/colors.scss";

#fiche-bu {
    .p-progressbar .p-progressbar-value {
        background-color: $primary_color !important;
    }

    .p-chip>span {
        font-size: 13px;
    }


    $base-evaluation-picto-radius: 40px;

    .evaluation-title-container {
        height: 50px;
        display: flex;
        align-items: center;
    }

    .evaluation-picto {
        height: $base-evaluation-picto-radius;
        width: $base-evaluation-picto-radius;
        border-radius: $base-evaluation-picto-radius;
        display: flex;
        align-items: center;

        i {
            font-size: 1.25em;
            margin: auto
        }
    }

    .ritual-item {
        width: 100%;

        .bloc-card {
            .bloc-index {
                border: 2px solid white;
            }
        }
    }

    .accident-img {
        height: 85px;
        width: 85px;
        border-radius: 50%;
        border: 5px solid white;
        top: -6px;
        left: 7px;
    }

    .bp-block .description {
        max-width: none;
    }
}
</style>
